<template>
  <footer class="footer">
    <div class="container-fluid">
      <!--<nav class="pull-left">
        <ul>
          <li>
            <a href="">
              Page Name
            </a>
          </li>
        </ul>
      </nav>-->
      <div class="copyright pull-right">
        <span style="color: white;">&copy; Banco Mundo Mujer S.A. - EMI - v{{ $store.getters.appVersion }}</span>
      </div>
    </div>
  </footer>
</template>
<script>
  export default {}

</script>
<style>

</style>
